import React from 'react';
import ReactDOM from 'react-dom';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import '../sass/app_strasko.scss';
import registerServiceWorker from './registerServiceWorker';
import Booking from './Booking';
import ReservationForm from './ReservationForm';

const bookingEl = document.getElementById('root')
const reservationsEl = document.getElementById('reservations')

bookingEl && ReactDOM.render(<Booking caretColor='#FFC20F' closeCaretColor='#15A7E0' />, bookingEl);
reservationsEl && ReactDOM.render(<ReservationForm caretColor='#FFC20F'/>, reservationsEl);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/js/index_strasko.js